var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAverageBlood = function SvgAverageBlood(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 11,
    viewBox: "0 0 8 11",
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 0C1.9242 2.13044 0 4.65219 0 6.91306C0 9.17393 1.79592 11 4 11C6.20408 11 8 9.17393 8 6.91306C8 4.65219 6.0758 2.13044 4 0ZM1.65597 6.28261C1.88921 6.26087 2.09912 6.41305 2.12245 6.63045C2.12245 6.66305 2.12245 6.69568 2.12245 6.71742C2.01749 7.50003 2.70554 8.63045 3.58017 9.0761C3.79009 9.18479 3.86006 9.42391 3.74344 9.6087C3.62682 9.79348 3.37026 9.86958 3.17201 9.76089C1.97085 9.15219 1.1312 7.83696 1.29446 6.61956C1.31778 6.43478 1.46939 6.2935 1.66764 6.27176L1.65597 6.28261Z",
    fill: "#010101"
  })));
};
export default SvgAverageBlood;